// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_3nRdk","item":"_1UNol","isCurrent":"_2XPul","disabled":"_1vvlh"};